import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { categoryService, CategoryDropdownItem } from '../../Services/CategoryService';

interface CategoryState {
  dropdownItems: CategoryDropdownItem[];
  loading: boolean;
  error: string | null;
}

const initialState: CategoryState = {
  dropdownItems: [],
  loading: false,
  error: null,
};

export const fetchCategoriesDropdown = createAsyncThunk(
  'category/fetchDropdown',
  async (_, { rejectWithValue }) => {
    try {
      const response = await categoryService.getDropdownCategories();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch categories');
    }
  }
);

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesDropdown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoriesDropdown.fulfilled, (state, action) => {
        state.loading = false;
        // Depending on backend structure, adapt here if it returns { data: ... }
        // We assume it returns an array of { value, label } or similar.
        // If it returns { id, name }, map it in the component or here.
        state.dropdownItems = action.payload as any;
      })
      .addCase(fetchCategoriesDropdown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default categorySlice.reducer;
